import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const DAY_OF_WEEK_VIDEO_REPORT_ID = `day-of-week${VIDEO_CAMPAIGN_SUFFIX}`;
